import styled from '@emotion/styled';

export const LeftSide = styled.div`
  min-width: 0;
  flex-grow: 1;
  align-self: flex-end;
  margin-left: var(--gutter-tiny);
  margin-right: var(--gutter-small);
`;

export const StyledHeader = styled.header`
  display: flex;
  position: relative;
  align-items: center;
  background: var(--color-core-primary);
  padding-right: var(--gutter);
  min-width: 0;
  gap: var(--gutter);
`;
